export default __webpack_public_path__ + "static/media/agenda2.c3ac42ed.png";